import { InjectionToken, Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, Inject, Optional, Input, NgModule, Directive, ElementRef, Self, ContentChild, forwardRef, NgZone, PLATFORM_ID, Renderer2, ContentChildren, HostListener, ViewChild, ComponentFactoryResolver, Injector, ViewContainerRef, Injectable, ApplicationRef, SkipSelf, TemplateRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { coerceBooleanProperty, ErrorStateMatcher, AbstractVxFormFieldDirective, AbstractVxFormFieldComponent, AbstractVxMenuComponent, VX_MENU_TOKEN, AbstractVxItemComponent, findInArrayByDirection, AbstractVxAttachMenuDirective, AUTOCOMPLETE_FILTER_FUNCTION, AbstractVxAutocompleteComponent, AbstractVxCheckboxComponent, AbstractVxDialogRef, AbstractVxDialogComponent, AbstractVxDialog, AbstractVxPageComponent, AbstractVxPagerComponent, VX_PAGER_TOKEN, AbstractVxPagerNextDirective, AbstractVxPagerPreviousDirective, AbstractVxRadioGroupComponent, VX_RADIO_GROUP_TOKEN, AbstractVxRadioButtonComponent, AbstractVxVerticalExpanderComponent, AbstractVxStepperComponent, VX_STEPPER_TOKEN, AbstractVxStepComponent } from 'vx-components-base';
import { __extends } from 'tslib';
import { NgControl, NgForm, FormGroupDirective, NG_VALIDATORS, CheckboxRequiredValidator } from '@angular/forms';
import { Subject, fromEvent, merge } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { FocusTrapFactory } from '@angular/cdk/a11y/';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var VX_BUTTON_DEFAULT_COLOR = new InjectionToken('VX_BUTTON_DEFAULT_COLOR');
/** @type {?} */
var VX_BUTTON_DEFAULT_VARIATION = new InjectionToken('VX_BUTTON_DEFAULT_VARIATION');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxButtonComponent = /** @class */ (function () {
    function VxButtonComponent(cdr, defaultColor, defaultVariation) {
        this.cdr = cdr;
        this._disabled = false;
        this.color = defaultColor || 'light';
        this._variation = defaultVariation || 'flat';
    }
    Object.defineProperty(VxButtonComponent.prototype, "variation", {
        get: /**
         * @return {?}
         */
        function () {
            return this._variation;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (!value) {
                value = 'flat';
            }
            this._variation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxButtonComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this.disabled) {
                this._disabled = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    VxButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: '[vx-button]',
                    // tslint:disable-line
                    template: "\n    <ng-content></ng-content>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        '[class.vx-button]': 'true',
                        '[class.vx-button-light]': "color === 'light'",
                        '[class.vx-button-dark]': "color === 'dark'",
                        '[class.vx-button-primary]': "color === 'primary'",
                        '[class.vx-button-accent]': "color === 'accent'",
                        '[class.vx-button-error]': "color === 'error'",
                        '[class.vx-button-success]': "color === 'success'",
                        '[class.vx-button-warn]': "color === 'warn'",
                        '[class.vx-button-flat]': "variation === 'flat'",
                        '[class.vx-button-raised]': "variation === 'raised'",
                        '[class.vx-button-stroked]': "variation === 'stroked'",
                        '[class.vx-disabled]': 'disabled'
                    },
                    styles: [".vx-button{display:inline-block;padding:10px 15px;border-radius:3px;outline:0;font-size:inherit;text-align:center;-webkit-tap-highlight-color:transparent;cursor:pointer;transition:background .2s}.vx-button.vx-disabled{cursor:auto;opacity:.65;pointer-events:none}.vx-button.vx-button-flat,.vx-button.vx-button-raised{border:0}.vx-button.vx-button-stroked{border-width:1px;border-style:solid}"]
                }] }
    ];
    /** @nocollapse */
    VxButtonComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Inject, args: [VX_BUTTON_DEFAULT_COLOR,] }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [VX_BUTTON_DEFAULT_VARIATION,] }, { type: Optional }] }
    ]; };
    VxButtonComponent.propDecorators = {
        value: [{ type: Input }],
        color: [{ type: Input }],
        variation: [{ type: Input, args: ['vx-button',] }],
        disabled: [{ type: Input }]
    };
    return VxButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxButtonModule = /** @class */ (function () {
    function VxButtonModule() {
    }
    VxButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxButtonComponent],
                    exports: [VxButtonComponent]
                },] }
    ];
    return VxButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxFormFieldDirective = /** @class */ (function (_super) {
    __extends(VxFormFieldDirective, _super);
    function VxFormFieldDirective(elementRef, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) {
        return _super.call(this, elementRef, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) || this;
    }
    /**
     * @return {?}
     */
    VxFormFieldDirective.prototype._onChange = /**
     * @return {?}
     */
    function () {
        this._dirtyCheckNativeValue();
    };
    /**
     * @return {?}
     */
    VxFormFieldDirective.prototype.focus = /**
     * @return {?}
     */
    function () {
        this.elementRef.nativeElement.focus();
    };
    /**
     * @protected
     * @return {?}
     */
    VxFormFieldDirective.prototype.getNativeValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return this.elementRef.nativeElement.value;
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    VxFormFieldDirective.prototype.setNativeValue = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this.elementRef.nativeElement.value = val;
    };
    VxFormFieldDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxFormField]',
                    exportAs: 'vxFormField',
                    host: {
                        '(blur)': '_setHasFocus(false)',
                        '(focus)': '_setHasFocus(true)',
                        '(input)': '_onChange()',
                        '[placeholder]': 'placeholder',
                        '[class.vx-form-field-input]': 'true',
                        '[attr.id]': 'id'
                    }
                },] }
    ];
    /** @nocollapse */
    VxFormFieldDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: ErrorStateMatcher },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] }
    ]; };
    return VxFormFieldDirective;
}(AbstractVxFormFieldDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxFormFieldComponent = /** @class */ (function (_super) {
    __extends(VxFormFieldComponent, _super);
    function VxFormFieldComponent(cdr) {
        var _this = _super.call(this, cdr) || this;
        _this.componentName = 'vx-form-field';
        _this.fieldDirectiveName = 'vxFormField';
        return _this;
    }
    VxFormFieldComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-form-field',
                    template: "<label class=\"vx-form-field-label\" *ngIf=\"field.label\" [attr.for]=\"field.id\">\n  {{ field.label }}\n  <span *ngIf=\"field.required && !field.hideRequiredMarker\" class=\"vx-form-field-required-label\">*</span>\n</label>\n<div class=\"vx-form-field-container\">\n  <ng-content></ng-content>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-form-field',
                        '[class.vx-error]': 'field.errorState',
                        '[class.vx-focused]': 'field.focused',
                        '[class.vx-disabled]': 'field.disabled'
                    },
                    styles: [".vx-form-field{display:inline-block;position:relative;vertical-align:middle}.vx-form-field.vx-disabled{opacity:.65;pointer-events:none;cursor:auto}.vx-form-field-container{position:relative;display:flex;align-items:center;flex-wrap:wrap;border-radius:3px;overflow:hidden;line-height:30px;transition:border-color .3s}.vx-form-field-label{font-size:12px;overflow:hidden;padding-bottom:2px;padding-right:10px;transition:color .3s}.vx-form-field-required-label{transition:color .3s}.vx-form-field-input{border:0;font-size:16px;outline:0;background:0 0;flex-grow:1;max-width:100%;margin:0;width:150px;height:20px;padding:7px;opacity:1;transition:color .3s}.vx-form-field-input::-webkit-input-placeholder{transition:color .3s}.vx-form-field-input::-moz-placeholder{transition:color .3s}.vx-form-field-input:-ms-input-placeholder{transition:color .3s}.vx-form-field-input::-ms-input-placeholder{transition:color .3s}.vx-form-field-input::placeholder{transition:color .3s}.vx-form-field-input[type=number]{-moz-appearance:textfield}.vx-form-field-input[type=number]::-webkit-inner-spin-button,.vx-form-field-input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}"]
                }] }
    ];
    /** @nocollapse */
    VxFormFieldComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    VxFormFieldComponent.propDecorators = {
        field: [{ type: ContentChild, args: [VxFormFieldDirective, { static: false },] }]
    };
    return VxFormFieldComponent;
}(AbstractVxFormFieldComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxFormFieldModule = /** @class */ (function () {
    function VxFormFieldModule() {
    }
    VxFormFieldModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxFormFieldComponent, VxFormFieldDirective],
                    exports: [VxFormFieldComponent, VxFormFieldDirective]
                },] }
    ];
    return VxFormFieldModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxItemComponent = /** @class */ (function (_super) {
    __extends(VxItemComponent, _super);
    function VxItemComponent(cdr, menu, _el) {
        var _this = _super.call(this, cdr, menu) || this;
        _this._el = _el;
        _this._active = false;
        return _this;
    }
    Object.defineProperty(VxItemComponent.prototype, "focused", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this._menu && ((/** @type {?} */ (this._menu))).focusedItem === this;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    VxItemComponent.prototype.getTextContent = /**
     * @return {?}
     */
    function () {
        if (this._transparentParent) {
            return this._transparentParent.getTextContent();
        }
        return this._el.nativeElement.textContent || '';
    };
    /**
     * @return {?}
     */
    VxItemComponent.prototype._markForCheck = /**
     * @return {?}
     */
    function () {
        this.cdr.markForCheck();
    };
    VxItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-item',
                    template: "<ng-template>\n  <ng-content></ng-content>\n</ng-template>\n<ng-container [ngTemplateOutlet]=\"_transparentChild?._template || _template\"></ng-container>\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        '[class.vx-item]': 'true',
                        '[class.vx-disabled]': 'disabled',
                        '[class.vx-focused]': 'focused',
                        '[class.vx-active]': '_active',
                        '(click)': '_handleSelect()'
                    },
                    styles: [".vx-item{display:block;width:100%;border:none;padding:15px;font-size:14px;text-align:left;font-family:inherit;box-sizing:border-box;cursor:pointer}.vx-item.vx-disabled{opacity:.65;pointer-events:none}"]
                }] }
    ];
    /** @nocollapse */
    VxItemComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: AbstractVxMenuComponent, decorators: [{ type: Inject, args: [VX_MENU_TOKEN,] }, { type: Optional }] },
        { type: ElementRef }
    ]; };
    return VxItemComponent;
}(AbstractVxItemComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var zIndex = 10000;
/**
 * @return {?}
 */
function getNextHighestZIndex() {
    return zIndex++;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OverlayRef = /** @class */ (function () {
    function OverlayRef(overlayClasses, containerClasses) {
        var _this = this;
        if (overlayClasses === void 0) { overlayClasses = []; }
        if (containerClasses === void 0) { containerClasses = []; }
        this.overlayHidden = true;
        this.overlayClickSubject = new Subject();
        overlayClasses.push('vx-overlay');
        containerClasses.push('vx-overlay-container');
        /** @type {?} */
        var container = document.createElement('div');
        container.className = containerClasses.join(' ');
        this.container = container;
        /** @type {?} */
        var overlay = document.createElement('div');
        overlay.className = overlayClasses.join(' ');
        this.container.appendChild(overlay);
        this.overlay = overlay;
        this.overlayDisplay = this.overlay.style.display || '';
        this.overlaySubscription = fromEvent(this.overlay, 'click').subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.overlayClickSubject.next(event);
        }));
        this.overlayClick = this.overlayClickSubject.asObservable();
    }
    /**
     * @return {?}
     */
    OverlayRef.prototype.hideOverlay = /**
     * @return {?}
     */
    function () {
        if (this.overlayHidden) {
            return;
        }
        this.overlayDisplay = this.overlay.style.display || '';
        this.overlay.style.display = 'none';
        this.overlayHidden = true;
        this.container.remove();
    };
    /**
     * @return {?}
     */
    OverlayRef.prototype.showOverlay = /**
     * @return {?}
     */
    function () {
        if (!this.overlayHidden) {
            return;
        }
        document.body.appendChild(this.container);
        this.overlay.style.display = this.overlayDisplay;
        this.overlayHidden = false;
        this.container.style.zIndex = "" + getNextHighestZIndex();
    };
    /**
     * @return {?}
     */
    OverlayRef.prototype.destroy = /**
     * @return {?}
     */
    function () {
        this.overlay.remove();
        this.container.remove();
        this.overlaySubscription.unsubscribe();
        this.overlayClickSubject.complete();
    };
    return OverlayRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxMenuComponent = /** @class */ (function (_super) {
    __extends(VxMenuComponent, _super);
    function VxMenuComponent(cdr, el, zone, platformId, renderer) {
        var _this = _super.call(this, cdr) || this;
        _this.el = el;
        _this.zone = zone;
        _this.renderer = renderer;
        /**
         * If setting to true or false is the same as setting all properties of VxMenuAutoClose to true or false
         */
        _this.autoClose = true;
        _this._focusedIdx = -1;
        _this.enterDown = false;
        _this.isPlatformBrowser = false;
        _this.isPlatformBrowser = isPlatformBrowser(platformId);
        if (_this.isPlatformBrowser) {
            _this.overlay = new OverlayRef(['vx-menu-overlay'], []);
            _this.overlay.overlayClick.subscribe((/**
             * @return {?}
             */
            function () {
                _this._autoClose('overlay');
            }));
            _this.positioner = document.createElement('div');
            _this.positioner.className = 'vx-menu-positioner';
            _this.overlay.container.appendChild(_this.positioner);
            _this.zone.runOutsideAngular((/**
             * @return {?}
             */
            function () {
                merge(fromEvent(window, 'scroll', { capture: true }), fromEvent(window, 'resize', { capture: true })).pipe(takeUntil(_this.onDestroy$)).subscribe((/**
                 * @return {?}
                 */
                function () {
                    _this.position();
                }));
            }));
        }
        else {
            // Remove the menu element from angular universal builds.
            _this.renderer.removeChild(_this.renderer.parentNode(_this.el.nativeElement), _this.el.nativeElement);
        }
        _this.itemSelect.pipe(takeUntil(_this.onDestroy$)).subscribe((/**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            _this._autoClose('itemSelect');
        }));
        return _this;
    }
    Object.defineProperty(VxMenuComponent.prototype, "_positionStrategyClass", {
        get: /**
         * @return {?}
         */
        function () {
            return this.__positionStrategyClass;
        },
        set: /**
         * @param {?} className
         * @return {?}
         */
        function (className) {
            if (this.el) {
                if (this.__positionStrategyClass) {
                    this.renderer.removeClass(this.el.nativeElement, this.__positionStrategyClass);
                }
                if (className) {
                    this.renderer.addClass(this.el.nativeElement, className);
                }
            }
            this.__positionStrategyClass = className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxMenuComponent.prototype, "focusedItem", {
        get: /**
         * @return {?}
         */
        function () {
            return this._focusedItem;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.focusedItem) {
                if (this.focusedItem) {
                    this.focusedItem._markForCheck();
                }
                this._focusedItem = value;
                if (value) {
                    value._markForCheck();
                    /** @type {?} */
                    var dropdown = this.el.nativeElement;
                    /** @type {?} */
                    var top_1 = value._el.nativeElement.offsetTop;
                    dropdown.scrollTop = top_1 - dropdown.offsetHeight / 4;
                }
                else {
                    this.el.nativeElement.scrollTop = 0;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxMenuComponent.prototype, "focusedIdx", {
        get: /**
         * @return {?}
         */
        function () {
            return this._focusedIdx;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var items = this.items.toArray();
            if (value >= items.length) {
                value = items.length - 1;
            }
            else if (value < 0) {
                value = 0;
            }
            /** @type {?} */
            var forward = value >= this.focusedIdx;
            /** @type {?} */
            var foundForward = findInArrayByDirection(items, value, (/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return !item.disabled; }), forward);
            if (foundForward) {
                this.focusedItem = (/** @type {?} */ (foundForward.item));
                this._focusedIdx = foundForward.idx;
                return;
            }
            /** @type {?} */
            var foundBackward = findInArrayByDirection(items, value, (/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return !item.disabled; }), !forward);
            if (foundBackward) {
                this.focusedItem = (/** @type {?} */ (foundBackward.item));
                this._focusedIdx = foundBackward.idx;
                return;
            }
            this.focusedItem = undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    VxMenuComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngAfterViewInit.call(this);
        if (this.positioner) {
            this.positioner.appendChild(this.el.nativeElement);
        }
    };
    /**
     * @return {?}
     */
    VxMenuComponent.prototype.hide = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.visible) {
            this.visible = false;
            return; // return because setting visible will re-call hide.
        }
        this._active = false;
        this.clearFocus();
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (_this.overlay) {
                _this.overlay.hideOverlay();
            }
        }), 300);
    };
    /**
     * @return {?}
     */
    VxMenuComponent.prototype.show = /**
     * @return {?}
     */
    function () {
        if (!this.attachedTo) {
            throw new Error('Tried showing a vx-menu without an attached element.');
        }
        if (!this.visible) {
            this.visible = true;
            return; // return because setting visible will re-call show
        }
        if (this._shouldAutoclose('overlay') && this.overlay) {
            this.overlay.showOverlay();
        }
        this.position();
    };
    /**
     * @return {?}
     */
    VxMenuComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.overlay) {
            this.overlay.destroy();
        }
    };
    /**
     * @param {?} upKey
     * @param {?} event
     * @return {?}
     */
    VxMenuComponent.prototype._onArrowDown = /**
     * @param {?} upKey
     * @param {?} event
     * @return {?}
     */
    function (upKey, event) {
        if (this.visible) {
            if (this.focusedIdx === -1) {
                this.focusedIdx = upKey ? this.items.length - 1 : 0;
            }
            else {
                this.focusedIdx += upKey ? -1 : 1;
            }
            event.preventDefault();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    VxMenuComponent.prototype._onEnterDown = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.visible && this.focusedItem) {
            this.focusedItem._active = true;
            event.preventDefault();
        }
        this.enterDown = true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    VxMenuComponent.prototype._onEnterUp = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.visible && this.focusedItem && this.enterDown) {
            this.focusedItem._active = false;
            this.focusedItem._handleSelect();
            event.preventDefault();
        }
    };
    /**
     * @param {?} reason
     * @return {?}
     */
    VxMenuComponent.prototype._autoClose = /**
     * @param {?} reason
     * @return {?}
     */
    function (reason) {
        if (this._shouldAutoclose(reason)) {
            this.visible = false;
        }
    };
    /**
     * @param {?} active
     * @return {?}
     */
    VxMenuComponent.prototype._setActive = /**
     * @param {?} active
     * @return {?}
     */
    function (active) {
        this._active = active;
    };
    /**
     * @protected
     * @param {?} reason
     * @return {?}
     */
    VxMenuComponent.prototype._shouldAutoclose = /**
     * @protected
     * @param {?} reason
     * @return {?}
     */
    function (reason) {
        return this.autoClose === true ? true : this.autoClose === false ? false : this.autoClose[reason] === true;
    };
    /**
     * @protected
     * @return {?}
     */
    VxMenuComponent.prototype.getAttachedPosition = /**
     * @protected
     * @return {?}
     */
    function () {
        if (!this.attachedTo) {
            return;
        }
        /** @type {?} */
        var rect = this.attachedTo.getBoundingClientRect();
        return {
            x: rect.left,
            y: rect.top,
            width: rect.width || this.attachedTo.offsetWidth,
            height: rect.height || this.attachedTo.offsetHeight
        };
    };
    /**
     * @protected
     * @return {?}
     */
    VxMenuComponent.prototype.getMenuPosition = /**
     * @protected
     * @return {?}
     */
    function () {
        if (!this.el || !this.el.nativeElement) {
            return;
        }
        /** @type {?} */
        var rect = this.el.nativeElement.getBoundingClientRect();
        return {
            x: rect.left,
            y: rect.top,
            width: rect.width || this.el.nativeElement.offsetWidth,
            height: this.el.nativeElement.scrollHeight + 2 // added 2 for the border
        };
    };
    /**
     * @protected
     * @return {?}
     */
    VxMenuComponent.prototype.getViewportSize = /**
     * @protected
     * @return {?}
     */
    function () {
        if (this.isPlatformBrowser) {
            /** @type {?} */
            var viewportHeight = Math.max(document.documentElement ? document.documentElement.clientHeight : 0, window.innerHeight || 0);
            /** @type {?} */
            var viewportWidth = Math.max(document.documentElement ? document.documentElement.clientWidth : 0, window.innerWidth || 0);
            return { width: viewportWidth, height: viewportHeight };
        }
    };
    /**
     * @protected
     * @param {?} pos
     * @param {?} autoWidth
     * @return {?}
     */
    VxMenuComponent.prototype.setNativePosition = /**
     * @protected
     * @param {?} pos
     * @param {?} autoWidth
     * @return {?}
     */
    function (pos, autoWidth) {
        if (!this.positioner) {
            return;
        }
        // el.style.top = `${pos.y}px`;
        this.positioner.style.transform = "translate(" + pos.x + "px, " + pos.y + "px)";
        /** @type {?} */
        var menuEl = this.el.nativeElement;
        menuEl.style.maxHeight = pos.height + "px";
        menuEl.style.width = autoWidth ? 'auto' : pos.width + "px";
        menuEl.style.maxWidth = autoWidth ? 'none' : pos.width + "px";
    };
    /**
     * @protected
     * @return {?}
     */
    VxMenuComponent.prototype.onItemsChanged = /**
     * @protected
     * @return {?}
     */
    function () {
        _super.prototype.onItemsChanged.call(this);
        this.clearFocus();
    };
    /**
     * @private
     * @return {?}
     */
    VxMenuComponent.prototype.clearFocus = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.focusedIdx !== -1) {
            this._focusedIdx = -1;
            this.focusedItem = undefined;
        }
    };
    /**
     * @protected
     * @param {?} menuPos
     * @return {?}
     */
    VxMenuComponent.prototype.getExpectedHeight = /**
     * @protected
     * @param {?} menuPos
     * @return {?}
     */
    function (menuPos) {
        if (this.maxHeight === 'none') {
            /** @type {?} */
            var menu = this.el.nativeElement;
            if (!menu) {
                return 200; // TODO: Is there a better value that could go here?
            }
            return menu.scrollHeight + 2; // Plus 2 for the border
        }
        return Math.min(menuPos.height, this.maxHeight);
    };
    VxMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-menu',
                    template: "<ng-content></ng-content>\n\n<span *ngIf=\"defaultText && (!items.length)\" class=\"vx-menu-default-text\">\n  {{defaultText}}\n</span>\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: VX_MENU_TOKEN, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxMenuComponent; }))
                        }
                    ],
                    host: {
                        'class': 'vx-menu',
                        '[class.vx-menu-visible]': 'visible'
                    },
                    styles: [".vx-menu{overflow:auto;-webkit-overflow-scrolling:touch;border-radius:3px;font-size:13px;display:inline-block;outline:0;originY:0;-webkit-transform:scale(1,0);transform:scale(1,0);opacity:0;box-sizing:border-box;transition:transform .2s,opacity .2s,-webkit-transform .2s;-webkit-transform-origin:top center;transform-origin:top center}.vx-menu.vx-menu-visible{-webkit-transform:scale(1,1);transform:scale(1,1);opacity:1}.vx-menu-positioner{position:relative;-webkit-transform:translate(0,0);transform:translate(0,0);z-index:1000;display:inline-block}.vx-menu-attached-top{-webkit-transform-origin:bottom center;transform-origin:bottom center}@-webkit-keyframes vx-menu-scale-animation{from{-webkit-transform:scale(0,0);transform:scale(0,0)}}@keyframes vx-menu-scale-animation{from{-webkit-transform:scale(0,0);transform:scale(0,0)}}.vx-menu-default-text{padding:10px;display:inline-block}"]
                }] }
    ];
    /** @nocollapse */
    VxMenuComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone },
        { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: Renderer2 }
    ]; };
    VxMenuComponent.propDecorators = {
        items: [{ type: ContentChildren, args: [VxItemComponent,] }],
        autoClose: [{ type: Input }],
        _onArrowDown: [{ type: HostListener, args: ['window:keydown.ArrowUp', ['true', '$event'],] }, { type: HostListener, args: ['window:keydown.ArrowDown', ['false', '$event'],] }],
        _onEnterDown: [{ type: HostListener, args: ['window:keydown.enter', ['$event'],] }],
        _onEnterUp: [{ type: HostListener, args: ['window:keyup.enter', ['$event'],] }],
        _autoClose: [{ type: HostListener, args: ['window:keydown.escape', ['"escape"'],] }, { type: HostListener, args: ['window:keydown.tab', ['"tab"'],] }],
        _setActive: [{ type: HostListener, args: ['mousedown', ['true'],] }, { type: HostListener, args: ['touchstart', ['true'],] }, { type: HostListener, args: ['window:mouseup', ['false'],] }, { type: HostListener, args: ['window:touchend', ['false'],] }]
    };
    return VxMenuComponent;
}(AbstractVxMenuComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxAttachMenuDirective = /** @class */ (function (_super) {
    __extends(VxAttachMenuDirective, _super);
    function VxAttachMenuDirective(el) {
        var _this = _super.call(this, el) || this;
        _this.directiveName = 'vxAttachMenu';
        return _this;
    }
    Object.defineProperty(VxAttachMenuDirective.prototype, "vxAttachMenu", {
        set: /**
         * @param {?} menu
         * @return {?}
         */
        function (menu) {
            this.menu = menu;
        },
        enumerable: true,
        configurable: true
    });
    VxAttachMenuDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxAttachMenu]'
                },] }
    ];
    /** @nocollapse */
    VxAttachMenuDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    VxAttachMenuDirective.propDecorators = {
        vxAttachMenu: [{ type: Input }]
    };
    return VxAttachMenuDirective;
}(AbstractVxAttachMenuDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxMenuTriggerDirective = /** @class */ (function () {
    function VxMenuTriggerDirective(el) {
        this.el = el;
    }
    Object.defineProperty(VxMenuTriggerDirective.prototype, "vxMenuTrigger", {
        set: /**
         * @param {?} menu
         * @return {?}
         */
        function (menu) {
            this.menu = menu;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    VxMenuTriggerDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.menu) {
            throw new Error('Tried using a [vxMenuTrigger] directive without passing a menu.');
        }
        if (!(this.menu instanceof VxMenuComponent)) {
            throw new Error('Tried using a [vxMenuTrigger] directive with an invalid menu.');
        }
    };
    /**
     * @return {?}
     */
    VxMenuTriggerDirective.prototype._handleClick = /**
     * @return {?}
     */
    function () {
        if (this.menu) {
            this.menu.attachedTo = this.el.nativeElement;
            this.menu.toggle();
        }
    };
    VxMenuTriggerDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxMenuTrigger]',
                    host: {
                        '(click)': '_handleClick()'
                    }
                },] }
    ];
    /** @nocollapse */
    VxMenuTriggerDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    VxMenuTriggerDirective.propDecorators = {
        vxMenuTrigger: [{ type: Input }]
    };
    return VxMenuTriggerDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxMenuModule = /** @class */ (function () {
    function VxMenuModule() {
    }
    VxMenuModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxAttachMenuDirective, VxMenuComponent, VxItemComponent, VxMenuTriggerDirective],
                    exports: [VxAttachMenuDirective, VxMenuComponent, VxItemComponent, VxMenuTriggerDirective]
                },] }
    ];
    return VxMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxAutocompleteComponent = /** @class */ (function (_super) {
    __extends(VxAutocompleteComponent, _super);
    function VxAutocompleteComponent(cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup, filterFunction) {
        var _this = _super.call(this, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup, filterFunction) || this;
        _this.tabIndex = 0;
        return _this;
    }
    /**
     * @return {?}
     */
    VxAutocompleteComponent.prototype.focus = /**
     * @return {?}
     */
    function () {
        if (this.searchable) {
            this._field.focus();
        }
        else {
            this.focusEl.nativeElement.focus();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    VxAutocompleteComponent.prototype._handleBackspace = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var val = this.value;
        if (!this.multiple || !(val instanceof Array)) {
            return;
        }
        if (!this._field.value && val.length) {
            this._removeItem(val[val.length - 1]);
            event.stopPropagation();
        }
    };
    VxAutocompleteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-autocomplete',
                    template: "<vx-form-field [vxAttachMenu]=\"menu\" (click)=\"focus()\" class=\"vx-autocomplete-form-field\"\n               [class.vx-focused]=\"menu.visible || field.focused\" (keyup.backspace)=\"_handleBackspace($event)\">\n\n  <button vx-button color=\"primary\" *ngFor=\"let item of _selectedItems\" class=\"vx-autocomplete-chip\"\n          (click)=\"_removeItem(item.value); $event.stopPropagation()\"\n          (keydown.backspace)=\"_removeItem(item.value); $event.stopPropagation();\">\n    <ng-container *ngTemplateOutlet=\"item._template\"></ng-container>\n<!--    {{item.getTextContent()}}-->\n\n    <span class=\"vx-autocomplete-chip-delete\">X</span>\n  </button>\n\n  <div class=\"vx-autocomplete-input-wrapper\" #focusEl [tabIndex]=\"searchable ? -1 : tabIndex\"\n       (blur)=\"searchable ? null : _handleFieldFocusChange(false)\"\n       (focus)=\"searchable ? null : _handleFieldFocusChange(true)\">\n    <input vxFormField [label]=\"label\" [placeholder]=\"placeholder\" #field=\"vxFormField\" autocomplete=\"off\"\n           (keydown.ArrowDown)=\"_showMenu()\" [attr.disabled]=\"!searchable || undefined\" [disabled]=\"disabled\">\n\n    <div class=\"vx-autocomplete-down-arrow\"></div>\n  </div>\n</vx-form-field>\n\n<vx-menu #menu [positionStrategy]=\"_positionStrategy\" width=\"match\" [defaultText]=\"defaultText\" class=\"vx-autocomplete-menu\">\n  <vx-item *ngFor=\"let item of _filteredItems\" [_transparentChild]=\"item\">\n  </vx-item>\n</vx-menu>\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'class': 'vx-autocomplete'
                    },
                    styles: [".vx-autocomplete{display:inline-flex;align-items:stretch}.vx-autocomplete-form-field{flex:1}.vx-autocomplete-input-wrapper{flex-grow:1;display:flex;flex-wrap:nowrap;outline:0}.vx-autocomplete-down-arrow{width:30px;cursor:pointer;position:relative;display:inline-block;vertical-align:middle}.vx-autocomplete-down-arrow::before{content:'';width:0;height:0;border-style:solid;border-width:7px 4px 0;position:absolute;pointer-events:none;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vx-button.vx-autocomplete-chip{font-size:12px;padding:7px;border-radius:8px;margin:2px 2px 2px 3px;vertical-align:middle;-webkit-animation:.3s vx-chip-entrance;animation:.3s vx-chip-entrance}@-webkit-keyframes vx-chip-entrance{from{-webkit-transform:scale(0,0);transform:scale(0,0)}to{-webkit-transform:scale(1,1);transform:scale(1,1)}}@keyframes vx-chip-entrance{from{-webkit-transform:scale(0,0);transform:scale(0,0)}to{-webkit-transform:scale(1,1);transform:scale(1,1)}}.vx-autocomplete-chip-delete{margin-left:2px;font-weight:700}.vx-menu.vx-autocomplete-menu-bottom{border-top-width:0;border-top-left-radius:0;border-top-right-radius:0}"]
                }] }
    ];
    /** @nocollapse */
    VxAutocompleteComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ErrorStateMatcher },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AUTOCOMPLETE_FILTER_FUNCTION,] }] }
    ]; };
    VxAutocompleteComponent.propDecorators = {
        _items: [{ type: ContentChildren, args: [VxItemComponent,] }],
        focusEl: [{ type: ViewChild, args: ['focusEl', { static: false },] }],
        tabIndex: [{ type: Input }]
    };
    return VxAutocompleteComponent;
}(AbstractVxAutocompleteComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxAutocompleteModule = /** @class */ (function () {
    function VxAutocompleteModule() {
    }
    VxAutocompleteModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, VxMenuModule, VxFormFieldModule, VxButtonModule],
                    declarations: [VxAutocompleteComponent],
                    exports: [VxAutocompleteComponent, VxItemComponent]
                },] }
    ];
    return VxAutocompleteModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxCheckboxRequiredValidatorDirective = /** @class */ (function (_super) {
    __extends(VxCheckboxRequiredValidatorDirective, _super);
    function VxCheckboxRequiredValidatorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VxCheckboxRequiredValidatorDirective.decorators = [
        { type: Directive, args: [{
                    /* tslint:disable-next-line:directive-selector */
                    selector: "vx-checkbox[required][formControlName], vx-checkbox[required][formControl], vx-checkbox[required][ngModel]",
                    providers: [{
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxCheckboxRequiredValidatorDirective; })),
                            multi: true
                        }],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] }
    ];
    return VxCheckboxRequiredValidatorDirective;
}(CheckboxRequiredValidator));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxCheckboxComponent = /** @class */ (function (_super) {
    __extends(VxCheckboxComponent, _super);
    function VxCheckboxComponent(cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) {
        var _this = _super.call(this, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) || this;
        _this.tabIndex = 0;
        return _this;
    }
    /**
     * @protected
     * @return {?}
     */
    VxCheckboxComponent.prototype.getNativeValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return this._checkbox.nativeElement.checked;
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    VxCheckboxComponent.prototype.setNativeValue = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this._checkbox.nativeElement.checked = val;
    };
    VxCheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-checkbox',
                    template: "<input type=\"checkbox\" #checkbox [name]=\"name\" [id]=\"id\" hidden>\n\n<span class=\"vx-checkbox-box\">\n</span>\n<label class=\"vx-checkbox-label\" [attr.for]=\"id\">\n  <ng-content></ng-content>\n</label>\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'class': 'vx-checkbox',
                        '[class.vx-checked]': 'checked',
                        '[class.vx-disabled]': 'disabled',
                        '[class.vx-error]': 'errorState',
                        '[class.vx-focused]': 'focused',
                        '[attr.tabIndex]': 'tabIndex',
                        '(focusin)': '_setHasFocus(true)',
                        '(focusout)': '_setHasFocus(false)',
                        '(keydown.space)': '_toggleFromNative()',
                        '(keydown.enter)': '_toggleFromNative()',
                        '(click)': '_toggleFromNative()'
                    },
                    styles: [".vx-checkbox{display:inline-block;position:relative;cursor:pointer;outline:0}.vx-checkbox.vx-disabled{opacity:.65;pointer-events:none}.vx-checkbox.vx-checked .vx-checkbox-box:after{transition:width .1s,height .2s,opacity .1s;height:13px;width:6px;opacity:1}.vx-checkbox-box{display:inline-block;height:20px;margin-right:5px;width:20px;border-radius:3px;position:relative}.vx-checkbox-box:after{content:'';-webkit-transform:scaleX(-1) rotate(145deg);transform:scaleX(-1) rotate(145deg);-webkit-transform-origin:left top;transform-origin:left top;display:block;position:absolute;left:1px;top:13px;height:0;width:0;transition:opacity .2s,width .2s,height .1s;opacity:0}.vx-checkbox-label{vertical-align:5px;cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    VxCheckboxComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ErrorStateMatcher },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] }
    ]; };
    VxCheckboxComponent.propDecorators = {
        tabIndex: [{ type: Input }],
        _checkbox: [{ type: ViewChild, args: ['checkbox', { static: true },] }],
        name: [{ type: Input }]
    };
    return VxCheckboxComponent;
}(AbstractVxCheckboxComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxCheckboxModule = /** @class */ (function () {
    function VxCheckboxModule() {
    }
    VxCheckboxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxCheckboxComponent, VxCheckboxRequiredValidatorDirective],
                    exports: [VxCheckboxComponent, VxCheckboxRequiredValidatorDirective]
                },] }
    ];
    return VxCheckboxModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template ComponentType, DataType, CloseDataType
 */
var  /**
 * @template ComponentType, DataType, CloseDataType
 */
VxDialogRef = /** @class */ (function (_super) {
    __extends(VxDialogRef, _super);
    function VxDialogRef(dialog) {
        var _this = _super.call(this, dialog) || this;
        if (dialog.overlay) {
            _this.onCancel = merge((/** @type {?} */ (dialog.overlay.overlayClick.pipe(map((/**
             * @return {?}
             */
            function () { return 'overlay'; }))))), (/** @type {?} */ (dialog.escapePress.pipe(map((/**
             * @return {?}
             */
            function () { return 'escape'; }))))));
        }
        else {
            _this.onCancel = (/** @type {?} */ (dialog.escapePress.pipe(map((/**
             * @return {?}
             */
            function () { return 'escape'; })))));
        }
        return _this;
    }
    return VxDialogRef;
}(AbstractVxDialogRef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template ComponentType, DataType, CloseDataType
 */
var VxDialogComponent = /** @class */ (function (_super) {
    __extends(VxDialogComponent, _super);
    function VxDialogComponent(resolver, injector, el, renderer, focusTrapFactory, platformId) {
        var _this = _super.call(this, resolver, injector) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.focusTrapFactory = focusTrapFactory;
        _this.escapePress = new Subject();
        _this.refType = VxDialogRef;
        _this.isPlatformBrowser = isPlatformBrowser(platformId);
        if (_this.isPlatformBrowser) {
            _this.overlay = new OverlayRef(['vx-dialog-overlay'], ['vx-dialog-container']);
        }
        return _this;
    }
    /**
     * @return {?}
     */
    VxDialogComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.savePreviouslyFocusedElement();
        if (this.overlay) {
            this.overlay.container.append(this.el.nativeElement);
            this.overlay.showOverlay();
        }
        if (!this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.el.nativeElement);
            this.focusTrap.focusInitialElementWhenReady();
        }
    };
    /**
     * @protected
     * @return {?}
     */
    VxDialogComponent.prototype.destroyNative = /**
     * @protected
     * @return {?}
     */
    function () {
        if (this.overlay) {
            this.overlay.destroy();
        }
        this.escapePress.complete();
        this.restoreFocus();
    };
    /**
     * @protected
     * @return {?}
     */
    VxDialogComponent.prototype.animateClosing = /**
     * @protected
     * @return {?}
     */
    function () {
        this.renderer.addClass(this.el.nativeElement, 'vx-dialog-closing');
    };
    /** Restores focus to the element that was focused before the dialog opened. */
    /**
     * Restores focus to the element that was focused before the dialog opened.
     * @private
     * @return {?}
     */
    VxDialogComponent.prototype.restoreFocus = /**
     * Restores focus to the element that was focused before the dialog opened.
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var toFocus = this._elementFocusedBeforeDialogWasOpened;
        // We need the extra check, because IE can set the `activeElement` to null in some cases.
        if (toFocus && typeof toFocus.focus === 'function') {
            toFocus.focus();
        }
        if (this.focusTrap) {
            this.focusTrap.destroy();
        }
    };
    /** Saves a reference to the element that was focused before the dialog was opened. */
    /**
     * Saves a reference to the element that was focused before the dialog was opened.
     * @private
     * @return {?}
     */
    VxDialogComponent.prototype.savePreviouslyFocusedElement = /**
     * Saves a reference to the element that was focused before the dialog was opened.
     * @private
     * @return {?}
     */
    function () {
        if (this.isPlatformBrowser) {
            this._elementFocusedBeforeDialogWasOpened = (/** @type {?} */ (document.activeElement));
            // if (this._elementFocusedBeforeDialogWasOpened &&
            //   typeof this._elementFocusedBeforeDialogWasOpened.blur === 'function') {
            //   this._elementFocusedBeforeDialogWasOpened.blur();
            // }
        }
    };
    VxDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-dialog',
                    template: "<ng-container #container></ng-container>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-dialog',
                        '(keydown.escape)': 'escapePress.next()'
                    },
                    styles: [".vx-dialog-container{display:flex;width:100vw;height:100vh;align-items:center;justify-content:center}.vx-dialog{position:relative;max-width:90vw;-webkit-overflow-scrolling:touch;box-sizing:border-box;padding:20px;z-index:2;border-radius:5px;-webkit-animation:.3s vx-dialog-animation;animation:.3s vx-dialog-animation}.vx-dialog.vx-dialog-closing{-webkit-animation:.3s forwards vx-dialog-animation-closing;animation:.3s forwards vx-dialog-animation-closing}@-webkit-keyframes vx-dialog-animation{from{-webkit-transform:scale(0,0);transform:scale(0,0);opacity:0}to{-webkit-transform:scale(1,1);transform:scale(1,1);opacity:1}}@keyframes vx-dialog-animation{from{-webkit-transform:scale(0,0);transform:scale(0,0);opacity:0}to{-webkit-transform:scale(1,1);transform:scale(1,1);opacity:1}}@-webkit-keyframes vx-dialog-animation-closing{from{-webkit-transform:scale(1,1);transform:scale(1,1);opacity:1}to{-webkit-transform:scale(0,0);transform:scale(0,0);opacity:0}}@keyframes vx-dialog-animation-closing{from{-webkit-transform:scale(1,1);transform:scale(1,1);opacity:1}to{-webkit-transform:scale(0,0);transform:scale(0,0);opacity:0}}.vx-dialog-title{margin:0 0 20px;display:block;font-size:20px;font-weight:500}.vx-dialog-content{overflow:auto;max-width:100%;max-height:65vh;display:block;margin:0 -20px;padding:0 20px}.vx-dialog-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;margin-top:20px}.vx-dialog-actions .vx-button{margin-left:10px}"]
                }] }
    ];
    /** @nocollapse */
    VxDialogComponent.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: ElementRef },
        { type: Renderer2 },
        { type: FocusTrapFactory },
        { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
    ]; };
    VxDialogComponent.propDecorators = {
        _contentViewContainer: [{ type: ViewChild, args: ['container', { read: ViewContainerRef, static: true },] }]
    };
    return VxDialogComponent;
}(AbstractVxDialogComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxDialog = /** @class */ (function (_super) {
    __extends(VxDialog, _super);
    function VxDialog(resolver, injector, appRef) {
        var _this = _super.call(this, resolver, injector, appRef) || this;
        _this.dialogType = VxDialogComponent;
        return _this;
    }
    // This is confusing but essentially makes the data parameter optional if the DataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    // This is confusing but essentially makes the data parameter optional if the DataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    /**
     * @template ComponentType, DataType
     * @param {?} component
     * @param {...?} data
     * @return {?}
     */
    VxDialog.prototype.open = 
    // This is confusing but essentially makes the data parameter optional if the DataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    /**
     * @template ComponentType, DataType
     * @param {?} component
     * @param {...?} data
     * @return {?}
     */
    function (component) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        return (/** @type {?} */ (_super.prototype.open.call(this, component, data[0])));
    };
    VxDialog.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    VxDialog.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: ApplicationRef }
    ]; };
    return VxDialog;
}(AbstractVxDialog));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxFocusInitialDirective = /** @class */ (function () {
    function VxFocusInitialDirective() {
    }
    VxFocusInitialDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxFocusInitial]',
                    host: {
                        '[attr.cdkFocusInitial]': 'true'
                    }
                },] }
    ];
    return VxFocusInitialDirective;
}());
/**
 * @template CloseDataType
 */
var VxDialogTitleDirective = /** @class */ (function () {
    function VxDialogTitleDirective(el) {
        this.el = el;
    }
    VxDialogTitleDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxDialogTitle]',
                    host: {
                        'class': 'vx-dialog-title'
                    }
                },] }
    ];
    /** @nocollapse */
    VxDialogTitleDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    return VxDialogTitleDirective;
}());
/**
 * @template CloseDataType
 */
var VxDialogContentDirective = /** @class */ (function () {
    function VxDialogContentDirective() {
    }
    VxDialogContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxDialogContent]',
                    host: {
                        'class': 'vx-dialog-content'
                    }
                },] }
    ];
    return VxDialogContentDirective;
}());
/**
 * @template CloseDataType
 */
var VxDialogActionsDirective = /** @class */ (function () {
    function VxDialogActionsDirective() {
    }
    VxDialogActionsDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxDialogActions]',
                    host: {
                        'class': 'vx-dialog-actions'
                    }
                },] }
    ];
    return VxDialogActionsDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxDialogModule = /** @class */ (function () {
    function VxDialogModule() {
    }
    VxDialogModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxDialogComponent, VxDialogTitleDirective, VxDialogContentDirective, VxDialogActionsDirective, VxFocusInitialDirective],
                    exports: [VxDialogTitleDirective, VxDialogContentDirective, VxDialogActionsDirective, VxFocusInitialDirective],
                    entryComponents: [VxDialogComponent],
                    providers: [VxDialog]
                },] }
    ];
    return VxDialogModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxPageComponent = /** @class */ (function (_super) {
    __extends(VxPageComponent, _super);
    function VxPageComponent(el, cdr, renderer) {
        var _this = _super.call(this, el, cdr) || this;
        _this.renderer = renderer;
        _this._visible = false;
        return _this;
    }
    /**
     * @param {?} current
     * @param {?} skipTransition
     * @return {?}
     */
    VxPageComponent.prototype.position = /**
     * @param {?} current
     * @param {?} skipTransition
     * @return {?}
     */
    function (current, skipTransition) {
        var _this = this;
        /** @type {?} */
        var el = this.el.nativeElement;
        if (!el) {
            return;
        }
        clearTimeout(this.timeout);
        // This is a kludgy way to set these classes because hostBinding doesn't work.
        // see https://github.com/angular/angular/issues/22560 for why
        // TODO: needs a better work-around.
        this.setClass(el, 'vx-skip-transition', skipTransition);
        this.setClass(el, 'vx-page-current', current);
        this.setClass(el, 'vx-page-left', this._left);
        this.setClass(el, 'vx-page-right', this._right);
        this._visible = true;
        // If we are animating away
        if (!current) {
            // Wait for the animation to end and hide.
            if (skipTransition) {
                this._visible = false;
            }
            else {
                this.timeout = setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this._visible = false;
                    _this.cdr.markForCheck();
                }), 350);
            }
        }
    };
    /**
     * @private
     * @param {?} el
     * @param {?} className
     * @param {?} shouldHaveClass
     * @return {?}
     */
    VxPageComponent.prototype.setClass = /**
     * @private
     * @param {?} el
     * @param {?} className
     * @param {?} shouldHaveClass
     * @return {?}
     */
    function (el, className, shouldHaveClass) {
        if (shouldHaveClass) {
            this.renderer.addClass(el, className);
        }
        else {
            this.renderer.removeClass(el, className);
        }
    };
    VxPageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-page',
                    template: "\n    <ng-content *ngIf=\"_visible\"></ng-content>\n  ",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'class': 'vx-page'
                    },
                    styles: [".vx-page{position:absolute;width:100%;transition:transform .35s;transition:transform .35s,-webkit-transform .35s;top:0;left:0;display:block;overflow:auto;padding:15px;box-sizing:border-box;max-height:100%;-webkit-overflow-scrolling:touch}.vx-page.vx-page-current{position:relative;-webkit-transform:translateX(0);transform:translateX(0)}.vx-page.vx-page-left{-webkit-transform:translateX(-100%);transform:translateX(-100%);pointer-events:none}.vx-page.vx-page-right{-webkit-transform:translateX(100%);transform:translateX(100%);pointer-events:none}.vx-page.vx-skip-transition{transition:none}"]
                }] }
    ];
    /** @nocollapse */
    VxPageComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: Renderer2 }
    ]; };
    return VxPageComponent;
}(AbstractVxPageComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxPagerNextDirective = /** @class */ (function (_super) {
    __extends(VxPagerNextDirective, _super);
    function VxPagerNextDirective(pager) {
        var _this = _super.call(this, pager) || this;
        if (!pager) {
            throw new Error('Trying to use vxPagerNext outside of a vx-pager');
        }
        return _this;
    }
    VxPagerNextDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxPagerNext]',
                    host: {
                        '(click)': '_handleClick()'
                    }
                },] }
    ];
    /** @nocollapse */
    VxPagerNextDirective.ctorParameters = function () { return [
        { type: AbstractVxPagerComponent, decorators: [{ type: Inject, args: [VX_PAGER_TOKEN,] }, { type: Optional }] }
    ]; };
    return VxPagerNextDirective;
}(AbstractVxPagerNextDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxPagerPreviousDirective = /** @class */ (function (_super) {
    __extends(VxPagerPreviousDirective, _super);
    function VxPagerPreviousDirective(pager) {
        var _this = _super.call(this, pager) || this;
        if (!pager) {
            throw new Error('Trying to use vxPagerPrevious outside of a vx-pager');
        }
        return _this;
    }
    VxPagerPreviousDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxPagerPrevious]',
                    host: {
                        '(click)': '_handleClick()'
                    }
                },] }
    ];
    /** @nocollapse */
    VxPagerPreviousDirective.ctorParameters = function () { return [
        { type: AbstractVxPagerComponent, decorators: [{ type: Inject, args: [VX_PAGER_TOKEN,] }, { type: Optional }] }
    ]; };
    return VxPagerPreviousDirective;
}(AbstractVxPagerPreviousDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxPagerComponent = /** @class */ (function (_super) {
    __extends(VxPagerComponent, _super);
    function VxPagerComponent(cdr) {
        return _super.call(this, cdr) || this;
    }
    VxPagerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-pager',
                    template: "<ng-content></ng-content>",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: VX_PAGER_TOKEN, useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxPagerComponent; })) }
                    ],
                    host: {
                        'class': 'vx-pager'
                    },
                    styles: [".vx-pager{display:block;overflow:hidden;position:relative}"]
                }] }
    ];
    /** @nocollapse */
    VxPagerComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    VxPagerComponent.propDecorators = {
        pages: [{ type: ContentChildren, args: [VxPageComponent,] }]
    };
    return VxPagerComponent;
}(AbstractVxPagerComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxPagerModule = /** @class */ (function () {
    function VxPagerModule() {
    }
    VxPagerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxPageComponent, VxPagerComponent, VxPagerPreviousDirective, VxPagerNextDirective],
                    exports: [VxPageComponent, VxPagerComponent, VxPagerPreviousDirective, VxPagerNextDirective]
                },] }
    ];
    return VxPagerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxRadioButtonComponent = /** @class */ (function (_super) {
    __extends(VxRadioButtonComponent, _super);
    function VxRadioButtonComponent(cdr, group) {
        var _this = _super.call(this, cdr, group) || this;
        _this.focused = false;
        _this.tabIndex = 0;
        _this.componentName = 'vx-radio-button';
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    VxRadioButtonComponent.prototype._handleSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.checked) {
            this.group._handleButtonSelect(this.value);
            event.stopPropagation();
        }
    };
    VxRadioButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-radio-button',
                    template: "<input type=\"radio\" [value]=\"value\" [checked]=\"checked\" [name]=\"name\" title=\"\" hidden>\n<div class=\"vx-radio-button-outline\">\n  <div class=\"vx-radio-button-fill\"></div>\n</div>\n<div class=\"vx-radio-button-content\">\n  <ng-content></ng-content>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        '[class.vx-radio-button]': 'true',
                        '[class.vx-error]': 'group.errorState',
                        '[class.vx-disabled]': 'disabled',
                        '[class.vx-checked]': 'checked',
                        '[class.vx-focused]': 'focused',
                        '[attr.tabIndex]': 'tabIndex',
                        '(focusin)': 'focused = true',
                        '(focusout)': 'focused = false',
                        '(keyup.space)': '_handleSelect($event)',
                        '(click)': '_handleSelect($event)'
                    },
                    styles: [".vx-radio-button{display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle;cursor:pointer;font-size:16px;outline:0;transition:background .3s}.vx-radio-button.vx-disabled{pointer-events:none;opacity:.65}.vx-radio-button-outline{display:inline-flex;width:20px;height:20px;align-items:center;justify-content:center;box-sizing:border-box;flex-shrink:0;border-radius:50%;transition:border-color .3s}.vx-radio-button-outline:focus{outline:0}.vx-radio-button-fill{border-radius:50%;width:10px;height:10px;box-sizing:border-box;-webkit-transform:scale(0);transform:scale(0);transition:transform .25s;transition:transform .25s,-webkit-transform .25s}.vx-checked .vx-radio-button-fill{-webkit-transform:scale(1);transform:scale(1)}.vx-radio-button-content{display:inline-block;line-height:inherit;padding-left:8px;padding-right:0}"]
                }] }
    ];
    /** @nocollapse */
    VxRadioButtonComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: AbstractVxRadioGroupComponent, decorators: [{ type: Inject, args: [VX_RADIO_GROUP_TOKEN,] }] }
    ]; };
    VxRadioButtonComponent.propDecorators = {
        tabIndex: [{ type: Input }]
    };
    return VxRadioButtonComponent;
}(AbstractVxRadioButtonComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var VxRadioGroupComponent = /** @class */ (function (_super) {
    __extends(VxRadioGroupComponent, _super);
    function VxRadioGroupComponent(cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) {
        return _super.call(this, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) || this;
    }
    VxRadioGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-radio-group',
                    template: "\n    <ng-content></ng-content>",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        '[class.vx-radio-group]': 'true',
                        '[class.vx-error]': 'errorState',
                        '[class.vx-disabled]': 'disabled',
                        '(keyup.ArrowRight)': '_next()',
                        '(keyup.ArrowDown)': '_next()',
                        '(keyup.ArrowLeft)': '_previous()',
                        '(keyup.ArrowUp)': '_previous()'
                    },
                    providers: [
                        {
                            provide: VX_RADIO_GROUP_TOKEN,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxRadioGroupComponent; }))
                        }
                    ],
                    styles: [".vx-radio-group{display:block}"]
                }] }
    ];
    /** @nocollapse */
    VxRadioGroupComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ErrorStateMatcher },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] }
    ]; };
    VxRadioGroupComponent.propDecorators = {
        buttons: [{ type: ContentChildren, args: [VxRadioButtonComponent,] }]
    };
    return VxRadioGroupComponent;
}(AbstractVxRadioGroupComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxRadioModule = /** @class */ (function () {
    function VxRadioModule() {
    }
    VxRadioModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxRadioButtonComponent, VxRadioGroupComponent],
                    exports: [VxRadioButtonComponent, VxRadioGroupComponent]
                },] }
    ];
    return VxRadioModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxSpinnerComponent = /** @class */ (function () {
    function VxSpinnerComponent() {
        this.color = 'primary';
    }
    VxSpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-spinner',
                    template: "<div class=\"vx-spinner-circle1 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle2 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle3 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle4 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle5 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle6 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle7 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle8 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle9 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle10 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle11 vx-spinner-circle\"></div>\n<div class=\"vx-spinner-circle12 vx-spinner-circle\"></div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-spinner',
                        '[class.vx-spinner-light]': "color === 'light'",
                        '[class.vx-spinner-dark]': "color === 'dark'",
                        '[class.vx-spinner-primary]': "color === 'primary'",
                        '[class.vx-spinner-accent]': "color === 'accent'",
                        '[class.vx-spinner-error]': "color === 'error'",
                        '[class.vx-spinner-success]': "color === 'success'",
                        '[class.vx-spinner-warn]': "color === 'warn'"
                    },
                    styles: [".vx-spinner{display:inline-block;width:50px;height:50px;position:relative}.vx-spinner-circle{width:100%;height:100%;position:absolute;left:0;top:0}.vx-spinner-circle:before{content:'';display:block;margin:0 auto;width:15%;height:15%;border-radius:100%;-webkit-animation:1.2s ease-in-out infinite both vx-circle-fade-delay;animation:1.2s ease-in-out infinite both vx-circle-fade-delay}.vx-spinner-circle.vx-spinner-circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.vx-spinner-circle.vx-spinner-circle2:before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.vx-spinner-circle.vx-spinner-circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.vx-spinner-circle.vx-spinner-circle3:before{-webkit-animation-delay:-1s;animation-delay:-1s}.vx-spinner-circle.vx-spinner-circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.vx-spinner-circle.vx-spinner-circle4:before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.vx-spinner-circle.vx-spinner-circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.vx-spinner-circle.vx-spinner-circle5:before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.vx-spinner-circle.vx-spinner-circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.vx-spinner-circle.vx-spinner-circle6:before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.vx-spinner-circle.vx-spinner-circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.vx-spinner-circle.vx-spinner-circle7:before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.vx-spinner-circle.vx-spinner-circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.vx-spinner-circle.vx-spinner-circle8:before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.vx-spinner-circle.vx-spinner-circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.vx-spinner-circle.vx-spinner-circle9:before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.vx-spinner-circle.vx-spinner-circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.vx-spinner-circle.vx-spinner-circle10:before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.vx-spinner-circle.vx-spinner-circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.vx-spinner-circle.vx-spinner-circle11:before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.vx-spinner-circle.vx-spinner-circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.vx-spinner-circle.vx-spinner-circle12:before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes vx-circle-fade-delay{0%,100%,39%{opacity:0}40%{opacity:1}}@keyframes vx-circle-fade-delay{0%,100%,39%{opacity:0}40%{opacity:1}}"]
                }] }
    ];
    VxSpinnerComponent.propDecorators = {
        color: [{ type: Input }]
    };
    return VxSpinnerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxSpinnerModule = /** @class */ (function () {
    function VxSpinnerModule() {
    }
    VxSpinnerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxSpinnerComponent],
                    exports: [VxSpinnerComponent],
                },] }
    ];
    return VxSpinnerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxVerticalExpanderComponent = /** @class */ (function (_super) {
    __extends(VxVerticalExpanderComponent, _super);
    function VxVerticalExpanderComponent(cdr, element) {
        var _this = _super.call(this, cdr) || this;
        _this.element = element;
        _this._showContent = false;
        _this.timeouts = [];
        return _this;
    }
    /**
     * @protected
     * @return {?}
     */
    VxVerticalExpanderComponent.prototype.animateExpansion = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        // TODO: Angular universal support here (and in this.initialize())?
        this.timeouts.forEach(clearTimeout);
        this.timeouts = [];
        if (this.expanded) {
            // Mark for check happens in caller.
            this._showContent = true;
            // We need this timeout to allow the content to render
            this.timeouts.push(setTimeout((/**
             * @return {?}
             */
            function () { return _this.initializeAnimation(); })));
        }
        else {
            this.initializeAnimation();
        }
    };
    /**
     * @protected
     * @return {?}
     */
    VxVerticalExpanderComponent.prototype.initialize = /**
     * @protected
     * @return {?}
     */
    function () {
        this.element.nativeElement.style.height = this.expanded ? 'auto' : '0';
    };
    /**
     * @private
     * @return {?}
     */
    VxVerticalExpanderComponent.prototype.initializeAnimation = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.content) {
            return;
        }
        /** @type {?} */
        var contentEl = this.content.nativeElement;
        /** @type {?} */
        var thisEl = this.element.nativeElement;
        /** @type {?} */
        var contentSize = contentEl.offsetHeight;
        // Initialize the height
        thisEl.style.height = this.expanded ? '0' : contentSize + "px";
        // Trigger the animation (Because of css we need to do this on another frame;
        /** @type {?} */
        var initializeTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            contentSize = contentEl.offsetHeight;
            thisEl.style.height = _this.expanded ? contentSize + "px" : '0';
        }));
        // Post animation changes;
        /** @type {?} */
        var finalizeTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            _this.finalizeAnimation();
        }), 300);
        this.timeouts.push(initializeTimeout, finalizeTimeout);
    };
    /**
     * @private
     * @return {?}
     */
    VxVerticalExpanderComponent.prototype.finalizeAnimation = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.expanded) {
            this.element.nativeElement.style.height = 'auto';
        }
        else {
            this._showContent = false;
            this.cdr.markForCheck();
        }
    };
    VxVerticalExpanderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-vertical-expander',
                    template: "<div #content *ngIf=\"_showContent\">\n  <ng-content></ng-content>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-vertical-expander',
                        '[class.vx-expanded]': 'expanded'
                    },
                    styles: [".vx-vertical-expander{display:block;height:0;overflow:hidden;transition:height .3s}"]
                }] }
    ];
    /** @nocollapse */
    VxVerticalExpanderComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef }
    ]; };
    VxVerticalExpanderComponent.propDecorators = {
        content: [{ type: ViewChild, args: ['content', { static: false },] }]
    };
    return VxVerticalExpanderComponent;
}(AbstractVxVerticalExpanderComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxVerticalExpanderModule = /** @class */ (function () {
    function VxVerticalExpanderModule() {
    }
    VxVerticalExpanderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [VxVerticalExpanderComponent],
                    exports: [VxVerticalExpanderComponent]
                },] }
    ];
    return VxVerticalExpanderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxStepComponent = /** @class */ (function (_super) {
    __extends(VxStepComponent, _super);
    function VxStepComponent(errorStateMatcher, cdr, stepper) {
        var _this = _super.call(this, errorStateMatcher, cdr, stepper) || this;
        if (!stepper) {
            throw new Error('Tried using a vx-step outside of a vx-stepper');
        }
        return _this;
    }
    VxStepComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-step',
                    template: "\n    <ng-template>\n      <ng-content></ng-content>\n    </ng-template>\n  ",
                    providers: [{
                            provide: ErrorStateMatcher,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxStepComponent; }))
                        }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    VxStepComponent.ctorParameters = function () { return [
        { type: ErrorStateMatcher, decorators: [{ type: SkipSelf }] },
        { type: ChangeDetectorRef },
        { type: AbstractVxStepperComponent, decorators: [{ type: Inject, args: [VX_STEPPER_TOKEN,] }, { type: Optional }] }
    ]; };
    return VxStepComponent;
}(AbstractVxStepComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxStepHeaderComponent = /** @class */ (function () {
    function VxStepHeaderComponent() {
        this.disabled = false;
    }
    VxStepHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-step-header',
                    template: "<div class=\"vx-step-status\">\n  {{number}}\n</div>\n<div class=\"vx-step-label\">\n  {{step.label}}\n  <!--<ng-container *ngIf=\"!step.stepLabel\">{{step.label}}</ng-container>-->\n  <!--<ng-container *ngIf=\"step.stepLabel\" [ngTemplateOutlet]=\"step.stepLabel.template\"></ng-container>-->\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-step-header',
                        '[class.vx-active]': 'active',
                        '[class.vx-disabled]': 'disabled'
                    },
                    styles: [".vx-step-header{overflow:hidden;outline:0;cursor:pointer;position:relative;display:flex;align-items:center;padding:15px;opacity:1;transition:opacity .3s}.vx-step-header.vx-disabled{opacity:.55}.vx-stepper-vertical .vx-step-header{padding:24px}.vx-step-status{border-radius:50%;height:24px;width:24px;margin-right:8px;flex:none;align-items:center;justify-content:center;display:flex;transition:background .5s}.vx-step-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:50px}"]
                }] }
    ];
    VxStepHeaderComponent.propDecorators = {
        step: [{ type: Input }],
        number: [{ type: Input }],
        disabled: [{ type: Input }],
        active: [{ type: Input }]
    };
    return VxStepHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxStepperComponent = /** @class */ (function (_super) {
    __extends(VxStepperComponent, _super);
    function VxStepperComponent(cdr) {
        var _this = _super.call(this, cdr) || this;
        _this._vertical = false;
        return _this;
    }
    Object.defineProperty(VxStepperComponent.prototype, "vertical", {
        get: /**
         * @return {?}
         */
        function () {
            return this._vertical;
        },
        set: /**
         * @param {?} vertical
         * @return {?}
         */
        function (vertical) {
            vertical = coerceBooleanProperty(vertical);
            if (vertical !== this.vertical) {
                this._vertical = vertical;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    VxStepperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-stepper',
                    template: "<ng-container *ngIf=\"!vertical\">\n  <!--HORIZONTAL -->\n  <div class=\"vx-horizontal-step-headers\">\n    <ng-container *ngFor=\"let step of _steps; let last = last; let idx = index;\">\n      <vx-step-header [step]=\"step\" [number]=\"idx + 1\" (click)=\"selectedStep = idx;\"\n                      [disabled]=\"_shouldDisable(step)\" [active]=\"selectedStep === idx\"></vx-step-header>\n      <div class=\"vx-step-header-line\" *ngIf=\"!last\"></div>\n    </ng-container>\n  </div>\n\n  <vx-pager [selectedPage]=\"selectedStep\">\n    <vx-page *ngFor=\"let step of _steps;\">\n      <ng-container [ngTemplateOutlet]=\"step._template\"></ng-container>\n    </vx-page>\n  </vx-pager>\n</ng-container>\n\n<ng-container *ngIf=\"vertical\">\n  <ng-container *ngFor=\"let step of _steps; let idx = index; let last = last;\">\n\n    <vx-step-header [step]=\"step\" [number]=\"idx + 1\" (click)=\"selectedStep = idx;\"\n                    [disabled]=\"_shouldDisable(step)\" [active]=\"selectedStep === idx\"></vx-step-header>\n\n\n    <div class=\"vx-step\" [class.vx-last-step]=\"last\">\n      <vx-vertical-expander [expanded]=\"selectedStep === idx\">\n        <div class=\"vx-vertical-step-content\">\n          <ng-container [ngTemplateOutlet]=\"step._template\"></ng-container>\n        </div>\n      </vx-vertical-expander>\n    </div>\n\n  </ng-container>\n</ng-container>\n",
                    providers: [{
                            provide: VX_STEPPER_TOKEN,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return VxStepperComponent; }))
                        }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'vx-stepper',
                        '[class.vx-horizontal-stepper]': '!vertical',
                        '[class.vx-stepper-vertical]': 'vertical'
                    },
                    styles: [":host{display:block}.vx-horizontal-step-headers{display:flex;white-space:nowrap;align-items:center}.vx-step-header-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -8px;min-width:20px}.vx-stepper-vertical .vx-step{position:relative;margin-left:36px}.vx-stepper-vertical .vx-step:not(.vx-last-step):before{content:' ';position:absolute;left:0;top:-16px;bottom:-16px}.vx-stepper .vx-pager{border:0}.vx-stepper .vx-page{padding:0 15px 15px}.vx-vertical-step-content{padding:0 20px 20px}"]
                }] }
    ];
    /** @nocollapse */
    VxStepperComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    VxStepperComponent.propDecorators = {
        _steps: [{ type: ContentChildren, args: [VxStepComponent,] }],
        vertical: [{ type: Input }]
    };
    return VxStepperComponent;
}(AbstractVxStepperComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxStepperModule = /** @class */ (function () {
    function VxStepperModule() {
    }
    VxStepperModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, VxPagerModule, VxVerticalExpanderModule],
                    declarations: [VxStepperComponent, VxStepComponent, VxStepHeaderComponent],
                    exports: [VxStepperComponent, VxStepComponent]
                },] }
    ];
    return VxStepperModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxTabLabelDirective = /** @class */ (function () {
    function VxTabLabelDirective(templateRef) {
        this.templateRef = templateRef;
    }
    VxTabLabelDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[vxTabLabel]'
                },] }
    ];
    /** @nocollapse */
    VxTabLabelDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    return VxTabLabelDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxTabComponent = /** @class */ (function () {
    function VxTabComponent() {
        this.label = '';
    }
    VxTabComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-tab',
                    template: "\n    <ng-template #template>\n      <ng-content></ng-content>\n    </ng-template>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    VxTabComponent.propDecorators = {
        label: [{ type: Input }],
        tabLabel: [{ type: ContentChild, args: [VxTabLabelDirective, { static: false },] }],
        _template: [{ type: ViewChild, args: [TemplateRef, { static: false },] }]
    };
    return VxTabComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxTabsComponent = /** @class */ (function () {
    function VxTabsComponent(cdr) {
        this.cdr = cdr;
    }
    Object.defineProperty(VxTabsComponent.prototype, "selectedTab", {
        /** The selected tab */
        get: /**
         * The selected tab
         * @return {?}
         */
        function () {
            return this._pager.selectedPage;
        },
        set: /**
         * @param {?} tab
         * @return {?}
         */
        function (tab) {
            this._pager.selectedPage = tab;
            this.cdr.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    VxTabsComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // Because our selectedTab bindings depend upon our child pager we need to check bindings after the pager is created.
        this.cdr.detectChanges();
        this._tabs.changes.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cdr.markForCheck();
        }));
    };
    /** Sets the selected tab to be the tabIdx */
    /**
     * Sets the selected tab to be the tabIdx
     * @param {?} tabIdx
     * @return {?}
     */
    VxTabsComponent.prototype.selectTab = /**
     * Sets the selected tab to be the tabIdx
     * @param {?} tabIdx
     * @return {?}
     */
    function (tabIdx) {
        this.selectedTab = tabIdx;
    };
    /**
     * @return {?}
     */
    VxTabsComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        this.selectedTab++;
    };
    /**
     * @return {?}
     */
    VxTabsComponent.prototype.previous = /**
     * @return {?}
     */
    function () {
        this.selectedTab--;
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    VxTabsComponent.prototype.test = /**
     * @param {?} tab
     * @return {?}
     */
    function (tab) {
        debugger;
    };
    VxTabsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vx-tabs',
                    template: "<div class=\"vx-tab-labels\">\n  <div *ngFor=\"let tab of _tabs; let idx= index; let first=first;\" (click)=\"selectTab(idx)\" [class.vx-active]=\"selectedTab === idx\"\n       class=\"vx-tab-label\">\n    <span class=\"vx-tab-label-separator\" *ngIf=\"!first && (selectedTab > idx || idx > (selectedTab + 1))\"></span>\n\n    <ng-container *ngIf=\"tab.tabLabel\"  [ngTemplateOutlet]=\"tab.tabLabel.templateRef\"></ng-container>\n    <ng-container *ngIf=\"!tab.tabLabel\">{{tab.label}}</ng-container>\n  </div>\n</div>\n<div class=\"vx-tab\">\n  <vx-pager>\n    <vx-page *ngFor=\"let tab of _tabs;\">\n      <ng-container [ngTemplateOutlet]=\"tab._template\"></ng-container>\n    </vx-page>\n  </vx-pager>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [":host{display:flex;flex-direction:column;max-height:inherit;max-width:inherit}.vx-tab-labels{height:35px;overflow:auto;white-space:nowrap;position:relative;padding-left:5px;padding-top:5px;border-top-left-radius:5px;border-top-right-radius:5px;flex-shrink:0}.vx-tab-label{display:inline-block;padding:5px 15px;box-sizing:border-box;line-height:25px;transition:background-color .3s;border-top-left-radius:8px;border-top-right-radius:8px;min-width:70px;height:35px;position:relative;top:0;text-align:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.vx-tab-label::after,.vx-tab-label::before{position:absolute;width:6px;height:6px;left:calc(100% - 3px);bottom:-3px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.vx-tab-label::before{left:-3px}.vx-tab-label.vx-active::after,.vx-tab-label.vx-active::before{content:''}.vx-tab{border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:30;overflow:hidden}.vx-tab-label-separator{position:absolute;width:1px;height:22px;left:0;top:50%;margin-top:-11px}"]
                }] }
    ];
    /** @nocollapse */
    VxTabsComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    VxTabsComponent.propDecorators = {
        _tabs: [{ type: ContentChildren, args: [VxTabComponent,] }],
        _pager: [{ type: ViewChild, args: [VxPagerComponent, { static: true },] }],
        selectedTab: [{ type: Input }]
    };
    return VxTabsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VxTabsModule = /** @class */ (function () {
    function VxTabsModule() {
    }
    VxTabsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, VxPagerModule],
                    declarations: [VxTabsComponent, VxTabComponent, VxTabLabelDirective],
                    exports: [VxTabsComponent, VxTabComponent, VxTabLabelDirective]
                },] }
    ];
    return VxTabsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var modules = [
    VxFormFieldModule,
    VxRadioModule,
    VxMenuModule,
    VxAutocompleteModule,
    VxButtonModule,
    VxPagerModule,
    VxTabsModule,
    VxCheckboxModule,
    VxStepperModule,
    VxVerticalExpanderModule,
    VxDialogModule,
    VxSpinnerModule
];
var VxComponentsModule = /** @class */ (function () {
    function VxComponentsModule() {
    }
    VxComponentsModule.decorators = [
        { type: NgModule, args: [{
                    imports: modules,
                    exports: modules
                },] }
    ];
    return VxComponentsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template DataType, CloseDataType
 */
var  /**
 * @template DataType, CloseDataType
 */
VxDialogDef = /** @class */ (function () {
    function VxDialogDef() {
    }
    return VxDialogDef;
}());

export { VX_BUTTON_DEFAULT_COLOR, VX_BUTTON_DEFAULT_VARIATION, VxAttachMenuDirective, VxAutocompleteComponent, VxAutocompleteModule, VxButtonComponent, VxButtonModule, VxCheckboxComponent, VxCheckboxModule, VxCheckboxRequiredValidatorDirective, VxComponentsModule, VxDialog, VxDialogActionsDirective, VxDialogComponent, VxDialogContentDirective, VxDialogDef, VxDialogModule, VxDialogRef, VxDialogTitleDirective, VxFocusInitialDirective, VxFormFieldComponent, VxFormFieldDirective, VxFormFieldModule, VxItemComponent, VxMenuComponent, VxMenuModule, VxMenuTriggerDirective, VxPageComponent, VxPagerComponent, VxPagerModule, VxPagerNextDirective, VxPagerPreviousDirective, VxRadioButtonComponent, VxRadioGroupComponent, VxRadioModule, VxSpinnerComponent, VxSpinnerModule, VxStepComponent, VxStepHeaderComponent, VxStepperComponent, VxStepperModule, VxTabComponent, VxTabLabelDirective, VxTabsComponent, VxTabsModule, VxVerticalExpanderComponent, VxVerticalExpanderModule };
//# sourceMappingURL=vx-components.js.map
